<template>
    <transition name="fade">
      <div class="back">
        <div
          v-show="open"
          class="contract-modal"
        >
          <transition name="drop-in">
            <div
              v-show="open"
              class="contract-modal-inner"
            >
              <div class="contract-modal-content">
                <div>
                    <div class="contract-modal-header">
                        <h3 class="contract-modal-header-title">
                        {{ openedContract.product }} {{ openedContract.number }}
                        </h3>
                    </div>
                    <div class="contract-modal-body">

                      <p class="contract-modal-body-form-field-label">
                        Гос.номер
                      </p>
                      <div class="contract-modal-body-form-field">{{ formData.plate_number }}</div>

                      <p class="contract-modal-body-form-field-label">
                        Марка/Модель
                      </p>
                      <div class="contract-modal-body-form-field">{{ formData.markAndModel }}</div>

                      <p class="contract-modal-body-form-field-label">
                        Дата страхового случая
                      </p>
                      <div class="contract-modal-body-form-field">{{ formData.incident_date }}</div>

                      <p class="contract-modal-body-form-field-label">
                        Сумма выплаты
                      </p>
                      <div class="contract-modal-body-form-field">{{ formData.payment_sum }}</div>

                      <p class="contract-modal-body-form-field-label">
                        Статус
                      </p>
                      <div class="contract-modal-body-form-field">{{ formData.payment_status }}</div>
                      <div class="steps">
                        <template v-for="(step, index) in steps" :key="index">
                          <div class="step" :class="{ active: index <= currentStep }">
                            <div class="circle-border">
                              <div class="circle">{{ index + 1 }}</div>
                              <div v-if="index < steps.length - 1" class="line" :class="{ activeLine: index < currentStep }"></div>

                            </div>
                            <div class="label">{{ step.title }}</div>
                          </div>
                          <!-- Не рисуем линию после последнего шага -->
                        </template>

                      </div>
                    </div>
                </div>
                <button
                  type="button"
                  class="close"
                  @click="close"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import { onMounted, onUnmounted } from "vue";
  import { useToast } from 'vue-toastification'
  import { JSEncrypt } from 'jsencrypt'
  import { Steps } from 'ant-design-vue';
  import axios from "axios";
  import store from "@/store";
  import router from "@/router";

  const toaster = useToast();


  export default {
    components: { ASteps: Steps, AStep: Steps.Step },
    props: {
      open: {
        type: Boolean,
        required: true,
      },
      openedContract: {
        type: {
          beneficiary_name: String,
          id: Number,
          incident_date: String,
          number: String,
          object: {
            mark: String,
            model: String,
            plate_number: String
          },
          payment_status: String,
          payment_sum: String,
          product: String,
        },
        required: true,
      }
    },
    data() {
        return {
            steps: [
              { title: 'Нет документов' },
              { title: 'Нет документов водителя' },
              { title: 'Нет счёта СТО' },
              { title: 'Согласование счёта СТО' },
              { title: 'Нет заявления для выплаты' },
              {title: 'Полный пакет документов'},
              {title: 'Урегулировано'}
            ],
            formData: {
              beneficiary_name: null,
              id: null,
              incident_date: null,
              number: null,
              plate_number: null,
              markAndModel: null,
              object: {
                mark: null,
                model: null,
                plate_number: null
              },
              payment_status: null,
              payment_sum: null,
              product: null,
            }
        };
    },
    emits: ['close'],
    setup(_, { emit }) {
      const close = () => {
     
        emit("close");
      };
      const handleKeyup = (event) => {
        if (event.keyCode === 27) {
          close();
        }
      };
  
      // onMounted(() => document.addEventListener("keyup", handleKeyup));
      onUnmounted(() => document.removeEventListener("keyup", handleKeyup));
      return { close };
    },
    watch: {
        open: function () {
          if (this.open) {
            document.documentElement.style.overflow = "hidden";
            return;
          }
          document.documentElement.style.overflow = "auto";
        },
        openedContract: function(){
          if(this.openedContract && this.openedContract.id){
            this.formData = {...this.openedContract, markAndModel: `${this.openedContract.object.mark}/${this.openedContract.object.model}`, payment_sum: this.openedContract.payment_sum ? `${this.openedContract.payment_sum}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' '): this.openedContract.payment_sum}
          }
        }
      },
    computed: {
        currentStep() {
          const index = this.steps.findIndex(item => item.title === this.openedContract.payment_tracking_status)
            if(index === -1){
              return 0;
            }
            return index;
        },
        stepStatus() {
            if (this.formData.payment_status === 'Отказан') return 'error';
            return 'process';
        }
    },
    methods: {
        handlePasswordConfirmationChange(e){
          this.password_confirmation = e
        },
        async downloadContract(){
          const response = await axios.get(this.openedContract.file_path, {
              responseType: 'blob', 
          })
          const blob = new Blob([response.data])
          const downloadUrl = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = downloadUrl
          link.download = `${this.openedContract.number}.pdf`
          document.body.appendChild(link)
          link.click()
          link.remove()

          window.URL.revokeObjectURL(downloadUrl)
        }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @mixin mobile {
    @media (min-width: 320px) and (max-width: 425px) {
      @content;
    }
  }
  @mixin tablet {
    @media (min-width: 425px) and (max-width: 768px) {
      @content;
    }
  }
  @mixin tablet-1024 {
    @media (min-width: 768px) and (max-width: 1024px) {
      @content;
    }
  }
  
  *,
  ::before,
  ::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .contract-steps{
    margin-top: 15px;
  }
  .open {
    background-color: red;
  }
  .forget_password{
    display: flex;
    justify-content: center;
    cursor: pointer;
    text-decoration: underline !important;
    margin-top: 10px;
    color: #007BFF;
  }
  .field-error{
    color: red !important;
  }
  .disabledField{
    background: #838484 !important;
  }
  .back{
    position: absolute;
    top: 15px;
    left: 30px;
    border: none;
    padding-right: 5px;
    background: #ffff;
    border-radius: 15px;
    font-size: 18px;
    cursor: pointer;
  }
  .close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    padding-right: 5px;
    background: #ffff;
    border-radius: 15px;
    &::after {
      display: inline-block;
      content: "x";
      margin-top: 15px;
      margin-right: 15px;
    }
  }
  .download_btn{
    width: 100%;
    padding: 9px;
    margin-top: 25px;
    border: none;
    background: #007BFF;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 8px;
  }
  .contract-modal{
    &-header{
        &-title{
            font-size: 24px;
            width: 100%;
            margin-top: 30px;

            @include mobile() {
                font-size: 18px;
                margin-top: 15px;
            }

            @include tablet() {
                font-size: 20px;
                margin-top: 20px;
            }
        }
        &-desc{
            text-align: center;
            font-size: 22px;
        }
    }
    &-body{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: 4px;
				@media (max-width: 767px) {
					margin-top: 0;
				}
        &-item{
            padding: 15px;
            box-sizing: border-box;
            background: #F7F7F6;
            width: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 9px;
            cursor: pointer;
            &-title{
                text-align: center;
            }
            &-recom{
                font-size: 14px;
                text-align: center;
                background: #37A979;
                color: #fff;
                padding: 10px 20px;
                border-radius: 9px;
            }
            &-desc{
                font-size: 14px;
                text-align: center;
                padding: 10px 0;
            }
            
            img{
                margin: 10px 0;
            }
        }
        &-form{
            // margin-top: 15px;
            width: 100%;
            &-field{
                width: 100%;
                min-height: 55px;
                padding: 15px;
                background: #EFEFEF;
                border: none;
                border-radius: 8px;
                display: flex;
                align-items: center;
                white-space: normal;
                word-break: break-word;
                line-height: 100%;
								@media (max-width: 767px) {
									font-size: 14px;
									padding: 10px;
									min-height: 44px;
									margin-top: 4px;
								}

                &-label{
                    color: #373737;
                    font-size: 16px;
                    margin-bottom: 10px;
                    margin-top: 15px;
										@media (max-width: 767px) {
											font-size: 14px;
											margin-top: 8px;
											margin-bottom: 0;
										}
                }
                &-file{
                    width: 100%;
                    padding: 15px 0;
                    border-radius: 8px;
                    background: #007BFF;
                    position: relative;
                    color: #fff;
                    text-align: center;
                    margin-bottom: 15px;
                    cursor: pointer;
                    input{
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        opacity: 0;
                    }
                }
            }
            button{
                width: 100%;
                padding: 15px 0;
                border-radius: 8px;
                background: #007BFF;
                margin-top: 15px;
                color: #fff;
                border: none;
                cursor: pointer;
            }
        }
    }
    }
  .contract-modal {
    // overflow: hidden;
    // overflow-y: scroll;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    padding-top: 5%;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1000 !important;
    // background: rgba(0, 0, 0, 0.1);
    &-inner {
      width: clamp(250px, 60%, 700px);
      margin: 10px auto;
      filter: drop-shadow(0px 4px 30px rgba(0, 0, 0, 0.13));
      z-index: 10000000 !important;
    }
    &-content {
      position: relative;
      background-color: #fff;
      background-clip: padding-box;
      border-radius: 15px;
      padding: 25px;

      @include mobile() {
        padding: 16px;
      }

      @include tablet() {
        padding: 20px;
      }
    }
    @include mobile() {
      &-inner {
        width: 90%;
        margin: 0 auto;
      }
    }
    @include tablet() {
      &-inner {
        width: 90%;
        margin: 0 auto;
      }
    }
    @include tablet-1024() {
      &-inner {
        width: 80%;
        margin: 0 auto;
      }
    }
  }
  
  .custom-steps .ant-steps-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.custom-icon {
  background-color: #00b050;
  color: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.step-title {
  margin-top: 8px;
  text-align: center;
  white-space: normal;
  max-width: 80px;
}

.steps {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-top: 30px;
  gap: 12px;
  padding-bottom: 4px;

  @media (max-width: 767px) {
    gap: 8px;
    margin-top: 20px;
  }
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 0 0 auto;
  min-width: 90px;

  @media (max-width: 767px) {
    min-width: 72px;
  }
}
.circle-border{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #636363;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;

  @media (max-width: 767px) {
    width: 40px;
    height: 40px;
  }
}
.circle {
  background: #636363;
  color: white;
  font-weight: bold;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 2px solid #636363;
  transition: all 0.3s;
  position: relative;
  z-index: 10;

  @media (max-width: 767px) {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }
}

.step.active .circle {
  background: #04B433;
  border-color: #04B433;
}
.step.active .circle-border {
  border-color: #04B433;
}

.label {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  max-width: 90px;
  white-space: normal;

  @media (max-width: 767px) {
    font-size: 11px;
    max-width: 72px;
  }
}

.line {
  height: 2px;
  background: #636363;
  position: absolute;
  top: calc(50% - 1px);
  left: 100%;
  right: -77px;

  @media (max-width: 767px) {
    right: -60px;
  }
}
.activeLine{
  background: #04B433;
}
  
  //animation --->
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  .drop-in-enter-active,
  .drop-in-leave-active {
    transition: all 0.3s ease-out;
  }
  .drop-in-enter-from,
  .drop-in-leave-to {
    opacity: 0;
    transform: translateY(-50px);
  }
  </style>
  